<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 09:39:14
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-18 16:22:41
-->
<template>
  <div id="notFound">
    <img :src="notFoundImg" class='notFoundImg' />
  </div>
</template>

<script>
import notFindPageImg from '@/assets/images/404.png'
export default {
  data () {
    return {
      notFoundImg: notFindPageImg
    }
  }
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.$router.replace({
  //       name: from.name,
  //       path: from.path,
  //       query: from.query
  //     })
  //   })
  // }
}
</script>

<style lang="less">
#notFound {
  width: 100%;
  height: 100vh;
  position: relative;
  .notFoundImg {
    width: 80%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
